export const PLAYBOOK_MAX_LENGTH = 20000;
export const PLAYBOOK_QUESTION_MAX_LENGTH = 500;
export const ASK_PLAYBOOK_TOOL = 'askPlaybook';

/**
 * The `askPlaybook` tool's output. Each shape names the consultant so a stored thread renders the name it was
 * answered under. `answered: false` covers a timeout, a failure, or a call past the per-run cap.
 */
export type AskPlaybookOutput =
  | { consultantName: string; question: string; reply: string }
  | { consultantName: string; covered: false }
  | { consultantName: string; answered: false };
